<template>
	<div class="order_run">
		<div class="orderDetail">
			<div class="item">
				<span>检测项目：</span>
				<span class="text" v-text="curGoods.goodsName"></span>
			</div>			
			<div class="item" v-if="curGoods.channelPrice < curGoods.basePrice">
				<span>检测价格：</span>
				<span class="text grayFont" v-text="curGoods.basePriceStr"></span>
			</div>
			<div class="item">
				<span v-if="curGoods.channelPrice >= curGoods.basePrice">检测价格：</span>
				<span v-if="curGoods.channelPrice < curGoods.basePrice">优惠价格：</span>
				<span class="text" v-text="curGoods.channelPriceStr"></span>
			</div>
			<div class="item">
				<span>检测简介：</span>
				<span class="text" v-text="curGoods.goodsDesc"></span>
			</div>
			<div class="item">
				<span>检测单位：</span>
				<span class="text">东莞微量精准医学检验实验室</span>
			</div>
			<!--<div class="item">
				<span>客服电话：</span>
				<span class="text">020-31602327</span>
			</div>-->
		</div>

		<div class="order_infor">

			<div class="infor_item status_now" v-if="channelId == 'hsxuuNDk861'">
				<span class="item_label">现状：</span>
				<van-radio-group v-model="currentStatus">
					<van-radio name="1" checked-color="#336799" class="this">基线</van-radio>
					<van-radio name="2" checked-color="#336799" class="this">治疗</van-radio>
				</van-radio-group>
			</div>
			
			<!--hsxuuNDk861     //郑州市第六人民医院（科研项目）   的渠道ID
02VuJAlB255    //疾控线下干血斑商品    的商品ID
D70uzxR2180     //新冠核酸检测服务—破解“假阴性”  的商品ID--   v-if=" goodsId != 'D70uzxR2180' && channelId != 'hsxuuNDk861' && goodsId != '02VuJAlB255'"-->
			<div class="infor_item status_now" v-else>
				<span class="item_label">现状：</span>
				<van-radio-group v-model="currentStatus">
					<van-radio name="1" checked-color="#336799" class="this">初筛</van-radio>
					<van-radio name="2" checked-color="#336799" class="this">治疗</van-radio>
					<van-radio name="0" checked-color="#336799" class="this">保密</van-radio>
				</van-radio-group>
			</div>
			
			<div class="infor_item status_now" v-if="channelId == 'hsxuuNDk861'">
				<span class="item_label">性别：</span>
				<van-radio-group v-model="sexStatus">
					<van-radio name="男" value="男" checked-color="#336799" class="this">男</van-radio>
					<van-radio name="女" value="女" checked-color="#336799" class="this">女</van-radio>
					<!--<van-radio name="保密" value="保密" checked-color="#336799" class="this">保密</van-radio>-->
				</van-radio-group>
			</div>
			<div class="infor_item">
				<span class="item_label">姓名：</span>
				<input type="text" v-model="takeBlood_n" @blur="checkName"  placeholder="请输入此检测者的姓名" />
				<p style="font-size: 12px;color: #666666;margin-top: 6px;padding-left: 24px; ">　　注意：开票抬头以下单姓名一致</p>
			</div>
			<div class="infor_item">
				<span class="item_label">电话：</span>
				<input type="text" v-model="takeBlood_t" @blur="checkPhone" placeholder="请输入此次检测者的电话" />
			</div>
			
			<div class="infor_item" v-if="goodsId == '02VuJAlB255'">
				<span class="item_label">查询：</span>
				<input type="text" v-model="snCode"  placeholder="请输入此次检测者的查询码"/>
			</div>

			<div class="infor_item" v-if="goodsId == 'D70uzxR2180'">
				<span class="item_label">身份证号：</span>
				<input type="text" v-model="takeBlood_id" @blur="checkManid" placeholder="请输入此次检测者的身份证号" style="width: 70%;"/>
			</div>

			<div class="channerSingle" v-if="channelId == 'hsxuuNDk861'">
				<div class="infor_item">
					<span class="item_label">年龄：</span>
					<input type="text" v-model="takeBlood_age" placeholder="请输入此次检测者的年龄" />
				</div>

				<div class="infor_item">
					<span class="item_label">民族：</span>
					<input class="inputstyle_small" type="text" v-model="takeBlood_mz" placeholder="请输入此次检测者的民族" />
				</div>
				<div class="infor_item">
					<span class="item_label">学历：</span>
					<van-dropdown-menu>
						<van-dropdown-item v-model="educationModel" :options="education" />
					</van-dropdown-menu>
				</div>
				<div class="infor_item">
					<span class="item_label">途径：</span>
					<van-dropdown-menu>
						<van-dropdown-item v-model="channelModel" :options="channelList" />
					</van-dropdown-menu>
				</div>
				<div class="infor_item">
					<span class="item_label">地区：</span>
					<div @click="toSelect" class="selectStyle">
						{{city}} {{county}}
						<i class="van-icon van-icon-arrow van-cell__right-icon">
              <!---->
            </i>
					</div>
					<van-popup v-model="showAddress" position="bottom" :style="{ height: '50%' }" class="addressBox">
						<van-area :area-list="areaList" :columns-num="colNum" :item-height="38" @confirm="confirmFn" @change="changeFn" @cancel="cancelFn" />
					</van-popup>
				</div>
				<div class="infor_item">
					<span class="item_label" style="width: 30%;">初始治疗时间：</span>
					<van-cell :value="dataTime" is-link @click="showDataTime" class="dateTime" />
					<van-action-sheet v-model="showTime" confirm-button-text="保存" class="dateTimeshow">
						<van-datetime-picker v-model="currentDate" type="date" :min-date="minDate" @confirm="confirm" @cancel="cancelFnTime" />
					</van-action-sheet>
					<!--<van-calendar v-model="showDate" @confirm="onConfirm" />-->
				</div>
			</div>
			<div class="infor_item" v-if="goodsId != 'D70uzxR2180'">
				<span class="item_label">备注：</span>
				<input type="text" placeholder="请输入您的主治医师,或其他备注（选填）" v-model="userRemark" />
			</div>
		</div>
		<!--知情同意书 -->
		<div class="letter" style="position: relative;" v-if="goodsId != 'D70uzxR2180'">
			<div>
				<van-checkbox v-model="checked" checked-color="#336799" class="thisb">已阅读并同意</van-checkbox>
			</div>
			<div @click="showPopup" class="blutfont" style="position: absolute;top: 13px;left: 120px;">《知情同意书》</div>
		</div>

		<div class="markbox">
			<van-popup v-model="show" :style="{ height: '93%' }" :overlay="false">
				<div class="letterMain">
					<div class="logo">
						<!--<img :src="$store.state.api.imgUrl + 'logo_unline.png'" alt />-->
					</div>
					<div class="letterTitle">检测服务知情同意书</div>
					<div class="letterContent">
						<p style="text-indent: 0;">尊敬的顾客: 您好!</p>						
						<p>感谢您选择东莞微量精准医学检验实验室（“微量精准检验”）为您提供的科研检测服务。在检测程序开始之前，请您仔细阅读以下条款,并认真填写知情声明。</p>
						<p>1、 此科研服务为自愿参与的有偿服务，本人同意承担相应检测费用。</p>
						<p>2、 此科研服务所产生的数据结果将被用于科学研究项目中，用于评价所检测项目的临床应用价值。</p>
						<p>3、 此科研服务通过受试者自行委托，或通过微量精准检验委托，对符合资格对象进行样本采集。</p>
						<p>4、 此科研服务将由符合资格的运输机构进行样本收集和运输，微量精准检验将承担相应费用。</p>
						<p>5、 此科研服务仅对送检样本负责，检测结果仅供科研及临床参考。</p>
						<p>6、 微量精准检验承诺仅将收到的样本用于本次检测或确证实验所需，未经用户许可不得用于其他用途。</p>
						<p>7、 微量精准检验承诺将遵守《个人信息保护法》，在未得到本人的同意前，不可将个人信息提供给任何第三方。</p>

						<!--<p style="text-indent: 0;margin:10px;width: 100%;overflow: hidden;">※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※※</p>-->
						<p style="font-weight: 700;text-indent: 0;">知情声明:</p>
						<p>我已认真阅读并充分了解以上内容，经慎重考虑，本人同意以上《检测服务知情同意书》所述内容并要求进行检测。</p>
						<div class="writeName">
							<span>
                受检者签名：
                <input type="text" class="inputstyle" placeholder />
              </span>
							<span>
                联系电话：
                <input type="text" class="inputstyle" placeholder />
              </span>
							<br />
							<span>
                日期：
                <input type="text" class="inputstyle" placeholder />
              </span>
						</div>
						<div class="writeName">
							<span>
                代理人签名：
                <input type="text" class="inputstyle" placeholder />
              </span>
							<span>
                联系电话：
                <input type="text" class="inputstyle" placeholder />
              </span>
							<br />
							<span>
                日期：
                <input type="text" class="inputstyle" placeholder />
              </span>
						</div>
					</div>
				</div>
			</van-popup>
			<div class="closebtn" v-show="show" @click="close">我已阅读，返回</div>
		</div>

		<div class="submitbox" @click="pay" :style="sure_order() ? '' : ''">确认</div>
	</div>
</template>

<script>
	//import sign from '@/components/sign/sign.vue';
	import qs from "qs";
	import api from "@/utils/js/api";
	import areaList from "@/utils/js/address.js";

	import "./orderun.scss";

	export default {
		//
		data() {
			return {
				checked: false,
				show: false,
				// 是否需要登录
				sign: false,
				userInfo: "",
				goodsId: "",
				channelId: "",
				number: 1,
				userId: "",
				token: "",
				// 采血人
				takeBlood_n: "",
				// 电话
				takeBlood_t: "",
				areaCode: "",
				// 登录按钮文字
				msg: "确认",
				show_bot: false,
				//现状
				currentStatus: "",
				userRemark: "",

				curGoods: "",
				params: "",

				//年龄
				takeBlood_age: "",
				//民族
				takeBlood_mz: "",
				//性别
				sexStatus: "",
				//学历
				educationModel: "",
				//查询码
				snCode:"",
				education: [{
						text: "请选择你的学历",
						value: ""
					},
					{
						text: "研究生",
						value: "研究生"
					},
					{
						text: "本科",
						value: "本科"
					},
					{
						text: "专科",
						value: "专科"
					},
					{
						text: "中职中技",
						value: "中职中技"
					},
					{
						text: "高中",
						value: "高中"
					},
					{
						text: "初中",
						value: "初中"
					},
					{
						text: "小学",
						value: "小学"
					},
					{
						text: "无",
						value: "无"
					},
					{
						text: "其他",
						value: "其他"
					}
				],
				//传播途径
				channelModel: "",
				channelList: [{
						text: "请选择传播途径",
						value: ""
					},
					{
						text: "异性性行为感染",
						value: "异性性行为感染"
					},
					{
						text: "同性性行为感染",
						value: "同性性行为感染"
					},
					{
						text: "血液接触感染",
						value: "血液接触感染"
					},
					{
						text: "母婴传播",
						value: "母婴传播"
					},
					{
						text: "其他",
						value: "其他"
					}
				],
				//时间选择
				minDate: new Date("1990/01/01"),
				maxDate: new Date(),
				showTime: false,
				dataTime: "",
				currentDate: new Date(),
				//地区
				showAddress: false,
				//areaList: areaList,
				colNum: "3", //省市区显示列数，3-省市区，2-省市，1-省
				city: "请选择所在地区",
				county: "",
				SelectProvinceName: "", //省
				SelectCityName: "", //市
				SelectCountyName: "", //区
				takeBlood_id: "" //身份证号
			};
		},

		components: {
			// sign
		},
		created() {
			if(this.$route.query.code && localStorage.getItem("get_openid")) {
				if(this.$route.query.channelId) {
					this.$store.commit({
						type: "comment",
						name: "channelId",
						channelId: this.$route.query.channelId
					});
				}
				localStorage.removeItem("get_openid");
				this.wechat_code(this.$route.query.code);
			} else if(!this.userInfo || !this.token) {
				this.wechat();
			}
		},

		beforeUpdate() {},
		beforeMount() {
			this.goodsId = this.$route.query.goodsId;
			this.channelId = this.$route.query.channelId;
			console.log(this.goodsId);
			console.log(this.channelId);
			this.$store.commit({
				type: "comment",
				name: "channelId",
				channelId: this.$route.query.channelId
			});
		},
		//地区选择
		computed: {
			areaList() {
				return areaList;
			}
		},
		mounted() {
			this.querycurGoods();
			//console.log("父传过来的", this.areaList);
		},

		// props: ['areaList'],
		methods: {
			//地区选择
			toSelect() {
				this.showAddress = true;
			},
			changeFn(event) {
				console.log("改变", event);
			},
			confirmFn(event) {
				this.showAddress = false;
				let arr, SelectProvinceName, SelectCityName, SelectCountyName;
				arr = event;
				this.SelectProvinceName = arr[0].name; // 省
				this.SelectCityName = arr[1].name; // 市
				this.SelectCountyName = arr[2].name; // 区
				this.city = this.SelectCityName;
				this.county = this.SelectCountyName;
				this.$emit("ProCityCountyVal", [
					this.SelectProvinceName,
					this.SelectCityName,
					this.SelectCountyName
				]);
				//console.log("点击了确定按钮",SelectProvinceName, SelectCityName,SelectCountyName);
			},
			cancelFn() {
				this.showAddress = false;
				console.log("点击了取消按钮");
			},
			//时间
			formatDate: function(d) {
				return(
					d.getFullYear() +
					"-" +
					this.p(d.getMonth() + 1) +
					"-" +
					this.p(d.getDate())
				);
			},
			p(s) {
				return s < 10 ? "0" + s : s;
			},
			confirm(d) {
				this.dataTime = this.formatDate(d);
				this.showTime = false;
				// console.log(this.dataTime); // 打印出了时间
			},
			cancel() {
				this.showTime = false;
			},
			showDataTime() {
				this.showTime = true;
			},
			cancelFnTime() {
				this.showTime = false;
				// console.log("点击了取消按钮");
			},

			// 是否可以提交订单
			sure_order() {
				// if(this.sign) return false;
				if(this.takeBlood_n && this.regTel(this.takeBlood_t)) return true;
				return false;
			},
			// 手机号正则
			regTel(phone) {
				if(!/^1[3456789]\d{9}$/.test(phone)) {
					return false;
				} else {
					return true;
				}
			},
			// 中文正则
			/*regName(name) {
				if(!/^[\u4e00-\u9fa5]+$/.test(name)) {
					return false;
				} else {
					return true;
				}
			},*/
			
			
	regName(name) {
		var ta = name.split(""),
			str_l = 0;
		var str_fa = Number(ta[0].charCodeAt());
		if ((str_fa >= 65 && str_fa <= 90) || (str_fa >= 97 && str_fa <= 122) || (str_fa > 19967 && str_fa < 40870)) {
			for (var i = 0; i <= ta.length - 1; i++) {
				str_l++;
				if (Number(ta[i].charCodeAt()) > 19968 && Number(ta[i].charCodeAt()) < 40870) {
					str_l++;
				}
			}
			if (str_l >= 4 && str_l <= 16) {
				return true;
			}
		}
		return false;
	},

			
			
			//身份证验证
			idCard(manid) {
        if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(manid)) {
        	return false;
				} else {
					return true;
				}
  },

			checkPhone() {
				if(!this.regTel(this.takeBlood_t))
					return this.$toast("请输入正确的手机号");
			},
			checkName() {
				if(!this.regName(this.takeBlood_n))
					return this.$toast("请输入至少2个汉字，或至少4个英文字母");
			},
			checkManid() {
				if(!this.idCard(this.takeBlood_id))
					return this.$toast("请输入正确的身份证号");
			},

			cancel() {
				this.isShow();
			},
			isShow() {
				this.show = !this.show;
			},
			//提交采血信息
			tj() {
				this.isShow();
			},
			// 知情同意书
			letter() {
				// if(this.sign) return this.$toast('请绑定手机号');
				this.$router.push({
					name: "letter",
					params: {
						target: "letter/letter"
					}
				});
			},
			showPopup() {
				this.show = true;
			},
			close() {
				this.show = false;
			},

			//查询订单信息
			querycurGoods() {
				console.log(this.goodsId);
				console.log(this.channelId);
				this.$http({
					url: api.goodsDetail,
					method: "post",
					data: {
						goodsId: this.goodsId,
						channelId: this.$store.state.channelId
						//orderUserId: this.userInfo.userId
					}
				}).then(res => {
					if(res.success) {
						this.curGoods = res.data;
						//this.orderGoodsList = res.data.orderGoodsList;
						//this.queryLogisticsList();
					} else {
						this.$toast({
							message: res.message,
							forbidClick: true
						});
					}
				});
			},
			//微信授权取code
			wechat() {
				console.log('wechat-login');
				var data = {
					appid: 'wxe6d64706308fd8b3',
					// redirect_uri: encodeURI('http://www.pantaoys.com/h5/login'),
					redirect_uri: encodeURI(window.location.href),
					//redirect_uri: encodeURI(window.location.href + '?' + qs.stringify(this.params)),
					response_type: 'code',
					scope: 'snsapi_userinfo',
					state: (new Date()).valueOf(),
				}
				localStorage.setItem('get_openid', '1');
				//location.href = api.wechat_auth + `?${qs.stringify(data)}#wechat_redirect`;
				location.href = api.wechat_auth + `?${qs.stringify(data)}`;
				
			},
			// 微信登录公众号
			wechat_code(_code) {
				this.$http({
					url: api.weChatOpenAccountLogin,
					method: 'post',
					data: {
						code: _code
					}
				}).then(res => {
					console.log('weChatOpenAccountLogin', res)
					if(res.success) {
						localStorage.setItem('token', res.data.token);
						localStorage.setItem('userInfo', JSON.stringify(res.data));
						this.login_text = "绑定手机";
						this.save_userInfo(true)
					} else {
						this.$toast(res.message);
					}

				})
			},
			// 登录过期判断
			verifyUser() {
				this.$http({
					url: api.verifyUser,
					method: 'post',
					data: {
						token: localStorage.getItem('token')
					}
				}).then(res => {
					if(!res.success) {
						console.log('登录信息过期')
						localStorage.removeItem('userInfo');
						localStorage.removeItem('token');
						this.$store.commit({
							type: 'eachComment',
							data: [{
									name: 'userInfo',
									userInfo: ''
								},
								{
									name: 'token',
									token: ''
								}
							]
						})
					}

					//解析url参数channelId等
					this.get_search();
				})
			},
			//解析url参数channelId等
			get_search() {
				if(!window.location.search) {
					//this.queryBannerByChannelId();
					//this.queryGoodClassList();

					return;
				}

				var search = qs.parse(window.location.search.substring(1));
				if(this.$store.state.is_target == search.target) {
					// this.queryBannerByChannelId();
					//this.queryGoodClassList();
					return;
				}

				this.$store.commit({
					type: 'comment',
					name: 'search',
					search: search
				})
				if(search.channelId) {
					this.getChannelId(search)
				} else if(search.target) {
					this.getTarget(search);
				} else {
					//正常查询
					// this.queryBannerByChannelId();
					//this.queryGoodClassList();
				}

			},
			// location.search获取渠道Id
			getChannelId(data) {
				this.$http({
					url: api.isChannelValid,
					method: 'post',
					data: {
						channelId: data.channelId,
						goodsId: data.goodsId || ''
					}
				}).then(res => {
					if(res.success && res.data) {
						if(res.data.type == 2) {
							if(res.data.validValue == 1) {
								this.$store.commit({
									type: 'comment',
									name: 'channelId',
									channelId: data.channelId
								})
								this.getTarget(data);
							} else if(res.data.validValue == 2) {
								this.$store.commit({
									type: 'comment',
									name: 'channelId',
									channelId: data.channelId
								})
								this.$toast(res.data.validMsg);
							} else if(res.data.validValue == 3) {
								this.getTarget(data)
							} else if(res.data.validValue == 4) {
								this.$toast(res.data.validMsg)
							}
						} else {
							if(res.data.isValid == 1) {
								this.$store.commit({
									type: 'comment',
									name: 'channelId',
									channelId: data.channelId
								})
							}
							this.getTarget(data);
						}
						console.log('当前渠道ID有效');
					} else {
						console.log('请求失败或当前渠道ID无效');
					}
					// 带入渠道Id查询
					//this.queryBannerByChannelId();
					//this.queryGoodClassList();
				}).catch(err => {
					//this.queryBannerByChannelId();
					//this.queryGoodClassList();
				})
			},
			//location.search获取target
			getTarget(data) {
				if(!data.target) return;
				// if(data.target && window.history.length > 1) return;
				if(this.$store.state.loginPath.indexOf(data.target) != -1 && !this.$store.state.userInfo && !this.$store.state.token) return this.wechat();
				this.$store.commit({
					type: 'comment',
					name: 'is_target',
					is_target: data.target
				})
				// if(data.code) delete data.code;
				setTimeout(() => {
					this.$router.push({
						name: data.target,
						query: data
					})
				}, 800)

			},

			// 保存更新userInfo
			save_userInfo() {
				var token = localStorage.getItem('token');
				var userInfo = JSON.parse(localStorage.getItem('userInfo')) || '';
				if(token && userInfo) {
					this.$store.commit({
						type: 'getUserInfo',
						must: true
					})
				}
				this.verifyUser();
			},
			//提交订单
			pay() {
				console.log(this.userInfo.userId, this.$store.state.curAddress);

				var data = {
					goodsId: this.goodsId,
					goodsNum: this.number,
					//channelId: this.$store.state.channelId,
					channelId: this.channelId,
					currentStatus: this.currentStatus, //现状
					bloodPhone: this.takeBlood_t, //电话
					bloodName: this.takeBlood_n, //姓名
					userRemark: this.userRemark, //备注

					//后续添加
					userAge: this.takeBlood_age, //年龄
					userSex: this.sexStatus, //性别
					userNation: this.takeBlood_mz, //民族
					userDegree: this.educationModel, //文化程度
					firstCureTime: this.dataTime, //初始治疗时间
					spreadWay: this.channelModel, //传播途径
					bloodProvince: this.SelectProvinceName, //省
					bloodCity: this.SelectCityName, //市
					bloodArea: this.SelectCountyName, //区
					
					snCode:this.snCode,//查询码

					//新冠状
					identity: this.takeBlood_id,
				};
				//	console.log(this.channelList)

				//if(!this.currentStatus) return this.$toast('请勾选现状');
				if(!this.regName(this.takeBlood_n))
					return this.$toast("请输入至少2个汉字，或至少4个英文字母");
				if(!this.regTel(this.takeBlood_t))
					return this.$toast("请输入正确的手机号");
				if(!this.checked) return this.$toast("请阅读并同意《知情同意书》");

				//有id必填
				if(this.sexStatus == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请选择您的性别");
				if(this.takeBlood_age == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请输入您的年龄");
				if(this.takeBlood_mz == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请输入您的民族");
				if(this.educationModel == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请选择您的文化程度");
				if(this.channelModel == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请选择传播途径");
				if(this.SelectCountyName == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请选择您的所在地区");
				if(this.dataTime == "" && this.channelId == "hsxuuNDk861")
					return this.$toast("请选择初始治疗时间");

				if(this.takeBlood_id == "" && this.goodsId == "D70uzxR2180")
					return this.$toast("请输入您的身份证号码");
					
				if(this.snCode == "" && this.goodsId == '02VuJAlB255')
					return this.$toast("请输入检测者查询码");

				this.$http({
					url: api.submitOrder,
					method: "post",
					data: data
				}).then(res => {
					if(res.success) {
						var userInfo = JSON.parse(localStorage.getItem("userInfo"));
						userInfo.currentStatus = data.currentStatus;
						userInfo.bloodPhone = data.bloodPhone;
						userInfo.bloodName = data.bloodName;
						userInfo.userRemark = data.userRemark;
						// userInfo.bloodProvince = data.bloodProvince;
						// userInfo.bloodCity = data.bloodCity;
						//后续添加
						userInfo.userAge = data.userAge;
						userInfo.userSex = data.userSex;
						userInfo.userNation = data.userNation;
						userInfo.userDegree = data.userDegree;
						userInfo.firstCureTime = data.firstCureTime;
						userInfo.spreadWay = data.spreadWay;
						userInfo.bloodProvince = data.bloodProvince;
						userInfo.bloodCity = data.bloodCity;
						userInfo.bloodArea = data.bloodArea;
						userInfo.snCode=data.snCode;
						//新冠状
						userInfo.identity = data.identity;
						localStorage.setItem("userInfo", JSON.stringify(userInfo));
						this.$store.commit({
							type: "getUserInfo",
							must: true
						});

						// window.location.href = window.location.host +  '/h5/pay?order' + res.data.orderNo;
						this.$router.replace({
							name: "payun",
							query: {
								orderNo: res.data.orderNo
								// goBack: -1
							}
						});
					} else {
						this.$toast(res.message);
					}
				});
			}
		}
	};
</script>